export const checkCompanyData = (jsonData) => {
    if (jsonData.tipo !== 'conductor') {
        return { valid: false, message: 'Formulario no es para tipo conductor' };
    }

    const { empresa, datos_bancarios } = jsonData.dato;

    if (!empresa || !empresa.sigla) {
        return { valid: false, message: 'Sigla no se encuentra' };
    }

    // Check if datos_bancarios is required based on sigla
    const requiresDatosBancarios = empresa.sigla !== 'SPR';

    if (requiresDatosBancarios) {
        if (!datos_bancarios) {
            return { valid: false, message: 'Datos bancarios son requeridos' };
        }

        // Check if all required fields in datos_bancarios are present
        const requiredFields = ['banco_id', 'tipo_cuenta_id', 'numero_cuenta','tipo_documento_id'];
        for (const field of requiredFields) {
            if (!datos_bancarios[field]) {
                return { valid: false, message: `El campo ${field} es requerido en datos bancarios` };
            }
        }
    } else {
        // Remove datos_bancarios if not required
        delete jsonData.dato.datos_bancarios;
    }

    return { valid: true, message: 'Compañía es válida' };
};